import { render } from "./ElectronicSecuritySystemPage.vue?vue&type=template&id=256e569d"
import script from "./ElectronicSecuritySystemPage.vue?vue&type=script&lang=js"
export * from "./ElectronicSecuritySystemPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__